"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property$setter = exports.Property$init = exports.Property$pendingInit = exports.Property$generateOwnProperty = exports.Property$generatePrototypeProperty = exports.Property$generateStaticProperty = exports.Property$generateShortcuts = exports.Property$format = exports.evaluateLabel = exports.getLabelSourceType = exports.getLabelFormat = exports.isPropertyOptions = exports.isPropertyBooleanFunction = exports.isPropertyBooleanFunctionAndOptions = exports.isPropertyValueFunction = exports.Property = void 0;
var events_1 = require("./events");
var format_1 = require("./format");
var type_1 = require("./type");
var property_chain_1 = require("./property-chain");
var helpers_1 = require("./helpers");
var observable_array_1 = require("./observable-array");
var rule_1 = require("./rule");
var calculated_property_rule_1 = require("./calculated-property-rule");
var string_format_rule_1 = require("./string-format-rule");
var validation_rule_1 = require("./validation-rule");
var allowed_values_rule_1 = require("./allowed-values-rule");
var required_rule_1 = require("./required-rule");
var range_rule_1 = require("./range-rule");
var string_length_rule_1 = require("./string-length-rule");
var list_length_rule_1 = require("./list-length-rule");
var initilization_context_1 = require("./initilization-context");
var condition_type_1 = require("./condition-type");
var defaulted_sub_properties_rule_1 = require("./defaulted-sub-properties-rule");
var Property = /** @class */ (function () {
    function Property(containingType, name, propertyType, isIdentifier, isList, options) {
        this.containingType = containingType;
        this.name = name;
        this.propertyType = propertyType;
        this.isIdentifier = isIdentifier;
        this.isList = isList;
        this.required = false;
        this.rules = [];
        this.getter = Property$makeGetter(this, Property$getter);
        this.setter = Property$makeSetter(this, Property$setter);
        this.changed = new events_1.Event();
        this.accessed = new events_1.Event();
        // Apply property options
        if (options)
            this.extend(options);
    }
    Object.defineProperty(Property.prototype, "isConstant", {
        get: function () {
            return this.constant !== null && this.constant !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Property.prototype, "labelIsFormat", {
        get: function () {
            return format_1.Format.hasTokens(this.label);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Property.prototype, "helptextIsFormat", {
        get: function () {
            return format_1.Format.hasTokens(this.helptext);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Property.prototype, "path", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Property.prototype, "firstProperty", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Property.prototype, "lastProperty", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Property.prototype.getLastTarget = function (obj) {
        return obj;
    };
    Object.defineProperty(Property.prototype, "defaultValue", {
        get: function () {
            if (this._defaultValue !== undefined) {
                // clone array and date defaults since they are mutable javascript types
                return this._defaultValue instanceof Array ? this._defaultValue.slice() :
                    this._defaultValue instanceof Date ? new Date(+this._defaultValue) :
                        // TODO: Implement TimeSpan class/type?
                        // this._defaultValue instanceof TimeSpan ? new TimeSpan(this._defaultValue.totalMilliseconds) :
                        this._defaultValue;
            }
            else
                return helpers_1.getDefaultValue(this.isList, this.propertyType);
        },
        enumerable: false,
        configurable: true
    });
    Property.prototype.extend = function (options, targetType) {
        var _this = this;
        if (!targetType)
            targetType = this.containingType;
        // Utility function to convert a path string into a resolved array of Property and PropertyChain instances
        function resolveDependsOn(property, rule, dependsOn) {
            // return an empty dependency array if no path was specified
            if (!dependsOn)
                return [];
            // throw an exception if dependsOn is not a string
            if (typeof (dependsOn) !== "string")
                throw new Error("Invalid dependsOn property for '" + rule + "' rule on '" + property + ".");
            // get the property paths for the specified dependency string
            return targetType.getPaths(dependsOn);
        }
        // Use prepare() to defer property path resolution while the model is being extended
        targetType.model.prepare(function () {
            options = __assign({}, options);
            // Label
            if (options.label)
                _this.label = options.label;
            else if (targetType.model.settings.autogeneratePropertyLabels && !_this.label)
                _this.label = _this.name.replace(/(^[a-z]+|[A-Z]{2,}(?=[A-Z][a-z]|$)|[A-Z][a-z]*)/g, " $1").trim();
            // Label Source
            if (options.labelSource) {
                if (typeof (options.labelSource) !== "string")
                    throw new Error("Invalid labelSource property for '" + _this + ".");
                targetType.model.ready(function () {
                    _this.labelSource = targetType.getPath(options.labelSource);
                });
            }
            // Helptext
            _this.helptext = options.helptext;
            // Format
            if (options.format) {
                // Specifier
                if (typeof (options.format) === "string") {
                    var format = options.format;
                    _this.format = targetType.model.getFormat(_this.propertyType, format);
                }
                // Format
                else if (options.format instanceof format_1.Format) {
                    // TODO: convert description/expression/reformat into a Format object
                    _this.format = options.format;
                }
                // String Format
                else if (helpers_1.isType(options.format, function (f) { return helpers_1.getTypeName(f) === "object" && f.expression; })) {
                    var format_2 = options.format;
                    targetType.model.ready(function () {
                        new string_format_rule_1.StringFormatRule(targetType, {
                            property: _this,
                            description: format_2.description,
                            message: format_2.message,
                            expression: format_2.expression,
                            reformat: format_2.reformat
                        })
                            .register();
                    });
                }
                // Error
                else {
                    throw new Error("Invalid 'format' option for '" + _this + "'.");
                }
            }
            // Constant
            if (options.constant !== null && options.constant !== undefined) {
                targetType.model.ready(function () {
                    // Lazily obtain the constant to ensure all types/rules associated with the constant value have been loaded and initialized
                    _this.constant = function () { return targetType.model.serializer.deserialize(null, options.constant, _this, new initilization_context_1.InitializationContext(true)); };
                });
            }
            // Get
            if (options.get) {
                if (typeof (options.get) === "function") {
                    options.get = { function: options.get, dependsOn: "" };
                }
                if (isPropertyOptions(options.get)) {
                    var getOptions_1 = options.get;
                    if (typeof (getOptions_1.function) !== "function") {
                        throw new Error("Invalid property 'get' function of type '" + helpers_1.getTypeName(getOptions_1.function) + "'.");
                    }
                    targetType.model.ready(function () {
                        new calculated_property_rule_1.CalculatedPropertyRule(targetType, null, {
                            property: _this,
                            calculate: getOptions_1.function,
                            onChangeOf: resolveDependsOn(_this, "get", getOptions_1.dependsOn)
                        }).register();
                    });
                }
                else {
                    throw new Error("Invalid property 'get' option of type '" + helpers_1.getTypeName(options.get) + "'.");
                }
            }
            // Set
            if (typeof options.set === "function") {
                var property_1 = _this;
                new rule_1.Rule(targetType, null, {
                    onInit: true,
                    onChangeOf: [_this],
                    execute: function () {
                        options.set.call(this, property_1.value(this));
                    }
                }).register();
            }
            // Init
            if (options.init !== undefined) {
                var initFn = void 0;
                if (isPropertyValueFunction(options.init))
                    initFn = options.init;
                else
                    throw new Error("Invalid property 'init' option of type '" + helpers_1.getTypeName(options.init) + "'.");
                _this.initializer = initFn;
            }
            // Default
            if (options.default !== undefined) {
                if (isPropertyValueFunction(options.default)) {
                    // Always generate a rule for default function
                    options.default = { function: options.default, dependsOn: "" };
                }
                else if (isPropertyOptions(options.default)) {
                    // Use default object as specified
                }
                else if (options.default === null || type_1.isValue(options.default) || type_1.isValueArray(options.default)) {
                    // Constant
                    var defaultConstant_1 = options.default;
                    // Cannot set default constant value for entity-typed property
                    if (type_1.isEntityType(_this.propertyType)) {
                        throw new Error("Cannot set a constant default value for a property of type '" + _this.propertyType.meta.fullName + "'.");
                    }
                    // Verify that the constant value is of the proper built-in type
                    if (options.default !== null && type_1.isValue(options.default)) {
                        var defaultOptionTypeName = helpers_1.getTypeName(defaultConstant_1);
                        var propertyTypeName = helpers_1.getConstructorName(_this.propertyType).toLowerCase();
                        if (defaultOptionTypeName !== propertyTypeName) {
                            throw new Error("Cannot set a default value of type '" + defaultOptionTypeName + "' for a property of type '" + propertyTypeName + "'.");
                        }
                    }
                    // If extending baseType property specifically for a child type, use a rule
                    if (_this.containingType === targetType)
                        _this._defaultValue = defaultConstant_1;
                    else
                        options.default = { function: function () { return defaultConstant_1; }, dependsOn: "" };
                }
                else {
                    throw new Error("Invalid property 'default' option of type '" + helpers_1.getTypeName(options.default) + "'.");
                }
                if (isPropertyOptions(options.default)) {
                    var defaultOptions_1 = options.default;
                    if (typeof (options.default.function) !== "function") {
                        throw new Error("Invalid property 'default' function of type '" + helpers_1.getTypeName(options.default.function) + "'.");
                    }
                    var defaultFn_1 = options.default.function;
                    targetType.model.ready(function () {
                        new calculated_property_rule_1.CalculatedPropertyRule(targetType, null, {
                            property: _this,
                            calculate: defaultFn_1,
                            onChangeOf: resolveDependsOn(_this, "default", defaultOptions_1.dependsOn),
                            isDefaultValue: true
                        }).register();
                    });
                }
            }
            // Defaults (Name and Address)
            if (options.defaults !== undefined && options.defaults !== null) {
                var defaultsRules_1 = options.defaults.map(function (def, index) {
                    var ruleName = targetType.fullName + "." + _this.name + ".DefaultedSubProperties." + index;
                    return { ruleName: ruleName, defaults: [def], dependsOn: def.dependsOn };
                });
                targetType.model.ready(function () {
                    // Create individual rules for each default function
                    defaultsRules_1.forEach(function (_a) {
                        var ruleName = _a.ruleName, defaults = _a.defaults, dependsOn = _a.dependsOn;
                        new defaulted_sub_properties_rule_1.DefaultedSubPropertiesRule(targetType, ruleName, {
                            property: _this,
                            defaults: defaults,
                            onChangeOf: dependsOn ? resolveDependsOn(_this, "defaults", dependsOn) : null,
                            onInitNew: true
                        }).register();
                    });
                });
            }
            // Allowed Values
            if (options.allowedValues) {
                if (typeof (options.allowedValues) === "function") {
                    var originalAllowedValues_1 = options.allowedValues;
                    var allowedValuesFunction = function () { return originalAllowedValues_1.call(this); };
                    options.get = { function: allowedValuesFunction, dependsOn: "" };
                }
                if (isPropertyOptions(options.allowedValues)) {
                    var allowedValuesOptions_1 = options.allowedValues;
                    if (typeof (options.allowedValues.function) !== "function") {
                        throw new Error("Invalid property 'allowedValues' function of type '" + helpers_1.getTypeName(options.allowedValues.function) + "'.");
                    }
                    targetType.model.ready(function () {
                        (new allowed_values_rule_1.AllowedValuesRule(targetType, {
                            property: _this,
                            source: allowedValuesOptions_1.function,
                            ignoreValidation: allowedValuesOptions_1.ignoreValidation,
                            preventInvalidValues: allowedValuesOptions_1.preventInvalidValues,
                            onChangeOf: resolveDependsOn(_this, "allowedValues", allowedValuesOptions_1.dependsOn)
                        })).register();
                    });
                }
                else {
                    throw new Error("Invalid property 'get' option of type '" + helpers_1.getTypeName(options.get) + "'.");
                }
            }
            // Range
            if (options.range) {
                var min_1;
                if (options.range.min != null) {
                    if (isPropertyValueFunction(options.range.min)) {
                        min_1 = options.range.min;
                    }
                    else if (type_1.isValue(options.range.min)) {
                        var minConstant_1 = options.range.min;
                        min_1 = function () { return minConstant_1; };
                    }
                    else {
                        throw new Error("Invalid property 'range.min' option of type '" + helpers_1.getTypeName(options.range.min) + "'.");
                    }
                }
                var max_1;
                if (options.range.max != null) {
                    if (isPropertyValueFunction(options.range.max)) {
                        max_1 = options.range.max;
                    }
                    else if (type_1.isValue(options.range.max)) {
                        var maxConstant_1 = options.range.max;
                        max_1 = function () { return maxConstant_1; };
                    }
                    else {
                        throw new Error("Invalid property 'range.max' option of type '" + helpers_1.getTypeName(options.range.max) + "'.");
                    }
                }
                targetType.model.ready(function () {
                    var onChangeOf = resolveDependsOn(_this, "range", options.range.dependsOn);
                    new range_rule_1.RangeRule(targetType, { property: _this, onChangeOf: onChangeOf, min: min_1, max: max_1 }).register();
                });
            }
            // Length
            if (options.length) {
                var min_2;
                if (options.length.min != null) {
                    if (isPropertyValueFunction(options.length.min)) {
                        min_2 = options.length.min;
                    }
                    else if (type_1.isValue(options.length.min, Number)) {
                        var minConstant_2 = options.length.min;
                        min_2 = function () { return minConstant_2; };
                    }
                    else {
                        throw new Error("Invalid property 'length.min' option of type '" + helpers_1.getTypeName(options.length.min) + "'.");
                    }
                }
                var max_2;
                if (options.length.max != null) {
                    if (isPropertyValueFunction(options.length.max)) {
                        max_2 = options.length.max;
                    }
                    else if (type_1.isValue(options.length.max, Number)) {
                        var maxConstant_2 = options.length.max;
                        max_2 = function () { return maxConstant_2; };
                    }
                    else {
                        throw new Error("Invalid property 'length.max' option of type '" + helpers_1.getTypeName(options.length.max) + "'.");
                    }
                }
                targetType.model.ready(function () {
                    var onChangeOf = resolveDependsOn(_this, "length", options.length.dependsOn);
                    if (_this.isList) {
                        new list_length_rule_1.ListLengthRule(targetType, { property: _this, onChangeOf: onChangeOf, min: min_2, max: max_2 }).register();
                    }
                    else {
                        new string_length_rule_1.StringLengthRule(targetType, { property: _this, onChangeOf: onChangeOf, min: min_2, max: max_2 }).register();
                    }
                });
            }
            // Required
            if (options.required) {
                var requiredOptions = options.required;
                // Store required options on property so that they can be referenced externally
                _this.required = requiredOptions;
                // Always Required
                if (typeof (options.required) === "boolean") {
                    if (options.required) {
                        targetType.model.ready(function () {
                            var requiredRule = new required_rule_1.RequiredRule(targetType, { property: _this });
                            requiredRule.register();
                        });
                    }
                }
                // Conditionally Required
                else {
                    var requiredFn_1;
                    var requiredMessage_1;
                    var requiredDependsOn_1;
                    if (isPropertyOptions(options.required)) {
                        requiredFn_1 = options.required.function;
                        requiredMessage_1 = options.required.message;
                        requiredDependsOn_1 = options.required.dependsOn;
                    }
                    else {
                        requiredFn_1 = options.required;
                    }
                    targetType.model.ready(function () {
                        (new required_rule_1.RequiredRule(targetType, {
                            property: _this,
                            when: requiredFn_1,
                            message: requiredMessage_1,
                            onChangeOf: requiredDependsOn_1 ? resolveDependsOn(_this, "required", requiredDependsOn_1) : null
                        })).register();
                    });
                }
            }
            // Error
            if (options.error) {
                (Array.isArray(options.error) ? options.error : [options.error]).forEach(function (errorOptions) {
                    var errorFn = errorOptions.function;
                    if (errorOptions.resource)
                        errorFn = function () {
                            return errorOptions.function.call(this) ? targetType.model.getResource(errorOptions.resource) : null;
                        };
                    var errorDependsOn = errorOptions.dependsOn;
                    if (typeof (errorFn) !== "function") {
                        throw new Error("Invalid property 'error' function of type '" + helpers_1.getTypeName(errorOptions.function) + "'.");
                    }
                    var conditionType;
                    if (errorOptions.code)
                        conditionType = condition_type_1.ConditionType.get(errorOptions.code) || new condition_type_1.ErrorConditionType(errorOptions.code, "error");
                    targetType.model.ready(function () {
                        (new validation_rule_1.ValidationRule(targetType, {
                            property: _this,
                            properties: errorOptions.properties ? helpers_1.flatMap(errorOptions.properties, function (p) { return targetType.getPaths(p); }) : null,
                            onChangeOf: resolveDependsOn(_this, "", errorDependsOn),
                            message: errorFn,
                            conditionType: conditionType
                        })).register();
                    });
                });
            }
        });
    };
    Property.prototype.equals = function (prop) {
        if (prop === null || prop === undefined) {
            return;
        }
        if (prop instanceof property_chain_1.PropertyChain) {
            return prop.equals(this);
        }
        if (prop instanceof Property) {
            return this === prop;
        }
    };
    Property.prototype.each = function (obj, callback, filter) {
        if (filter === void 0) { filter = null; }
        if (!filter || filter === this)
            callback(obj, this);
    };
    Property.prototype.toString = function () {
        return "this<" + this.containingType + ">." + this.name;
    };
    Property.prototype.canSetValue = function (obj, val) {
        // NOTE: only allow values of the correct data type to be set in the model
        if (val === undefined) {
            // TODO: Warn about setting value to undefined?
            // logWarning("You should not set property values to undefined, use null instead: property = ." + this._name + ".");
            // console.warn(`You should not set property values to undefined, use null instead: property = ${this.name}.`);
            return true;
        }
        if (val === null) {
            return true;
        }
        // for entities check base types as well
        if (val.constructor && val.constructor.meta) {
            for (var valType = val.constructor.meta; valType; valType = valType.baseType) {
                if (valType.jstype === this.propertyType) {
                    return true;
                }
            }
            return false;
        }
        // Data types
        else {
            var valObjectType = val.constructor;
            // "Normalize" data type in case it came from another frame as well as ensure that the types are the same
            switch (helpers_1.getTypeName(val)) {
                case "string":
                    valObjectType = String;
                    break;
                case "number":
                    valObjectType = Number;
                    break;
                case "boolean":
                    valObjectType = Boolean;
                    break;
                case "date":
                    valObjectType = Date;
                    break;
                case "array":
                    valObjectType = Array;
                    break;
            }
            // value property type check
            return valObjectType === this.propertyType ||
                // entity array type check
                (valObjectType === Array && this.isList && (!this.propertyType || val.every(function (child) {
                    if (type_1.isEntityType(this.propertyType)) {
                        if (child.constructor && child.constructor.meta) {
                            for (var childType = child.constructor.meta; childType; childType = childType.baseType) {
                                if (childType.jstype === this.propertyType) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                    else {
                        var itemObjectType = child.constructor;
                        // "Normalize" data type in case it came from another frame as well as ensure that the types are the same
                        switch (helpers_1.getTypeName(child)) {
                            case "string":
                                itemObjectType = String;
                                break;
                            case "number":
                                itemObjectType = Number;
                                break;
                            case "boolean":
                                itemObjectType = Boolean;
                                break;
                            case "date":
                                itemObjectType = Date;
                                break;
                            case "array":
                                itemObjectType = Array;
                                break;
                        }
                        return itemObjectType === this.propertyType;
                    }
                }, this)));
        }
    };
    Property.prototype.value = function (obj, val, additionalArgs) {
        if (obj === void 0) { obj = null; }
        if (val === void 0) { val = null; }
        if (additionalArgs === void 0) { additionalArgs = null; }
        if (obj === undefined || obj === null) {
            throw new Error("Cannot " + (arguments.length > 1 ? "set" : "get") + " value for property \"" + this.name + "\" on type \"" + this.containingType + "\": target is null or undefined.");
        }
        if (arguments.length > 1) {
            Property$setter(this, obj, val, additionalArgs);
        }
        else {
            return Property$getter(this, obj);
        }
    };
    Property.prototype.isInited = function (obj) {
        // If the backing field has been created, the property is initialized
        return obj.__fields__.hasOwnProperty(this.name);
    };
    return Property;
}());
exports.Property = Property;
function isPropertyValueFunction(obj) {
    return typeof (obj) === "function";
}
exports.isPropertyValueFunction = isPropertyValueFunction;
function isPropertyBooleanFunctionAndOptions(obj) {
    return typeof (obj) === "object";
}
exports.isPropertyBooleanFunctionAndOptions = isPropertyBooleanFunctionAndOptions;
function isPropertyBooleanFunction(obj) {
    return typeof (obj) === "function";
}
exports.isPropertyBooleanFunction = isPropertyBooleanFunction;
function isPropertyOptions(obj, check) {
    if (check === void 0) { check = null; }
    return helpers_1.isType(obj, function (d) { return helpers_1.getTypeName(d) === "object" && (!check || check(d)); });
}
exports.isPropertyOptions = isPropertyOptions;
/**
 * Gets a format object for the given property's label, if it is dynamic (i.e. contains format tokens)
 */
function getLabelFormat(property) {
    if (property.label && property.labelIsFormat) {
        var labelSourceType = getLabelSourceType(property);
        return labelSourceType.model.getFormat(labelSourceType.jstype, property.label);
    }
}
exports.getLabelFormat = getLabelFormat;
/**
 * Gets the model type of the source object that should be used to evaluate the
 * property's label, if it is dynamic (i.e. contains format tokens)
 */
function getLabelSourceType(property) {
    // If a label source is specified, then determine it's model type
    if (property.labelSource) {
        var labelSourceType = property.labelSource.propertyType;
        if (type_1.isEntityType(labelSourceType))
            return labelSourceType.meta;
    }
    return property.containingType;
}
exports.getLabelSourceType = getLabelSourceType;
/**
 * Evaluates the given property's label, using the given entity as context if the label is dynamic (i.e. contains format tokens)
 */
function evaluateLabel(property, entity) {
    if (property.labelIsFormat) {
        var labelFormat = getLabelFormat(property);
        var labelFormatInstance = entity;
        if (property.labelSource) {
            labelFormatInstance = property.labelSource.value(entity);
        }
        return labelFormat.convert(labelFormatInstance);
    }
    else {
        return property.label;
    }
}
exports.evaluateLabel = evaluateLabel;
function Property$format(prop, val) {
    if (prop.format) {
        return prop.format.convert(val);
    }
}
exports.Property$format = Property$format;
// export function Property$equals(prop1: Property | IPropertyChain, prop2: Property | IPropertyChain): boolean {
// 	if (prop1 === null || prop1 === undefined || prop2 === null || prop2 === undefined) {
// 		return;
// 	}
// 	if (PropertyChain$isPropertyChain(prop1)) {
// 		return (prop1 as PropertyChain).equals(prop2);
// 	}
// 	if (PropertyChain$isPropertyChain(prop2)) {
// 		return (prop2 as PropertyChain).equals(prop1);
// 	}
// 	if (Property$isProperty(prop1) && Property$isProperty(prop2)) {
// 		return prop1 === prop2;
// 	}
// }
function Property$generateShortcuts(property, target, overwrite) {
    if (overwrite === void 0) { overwrite = null; }
    var shortcutName = "$" + property.name;
    if (!(Object.prototype.hasOwnProperty.call(target, shortcutName)) || overwrite) {
        target[shortcutName] = property;
    }
}
exports.Property$generateShortcuts = Property$generateShortcuts;
function Property$generateStaticProperty(property, target) {
    Object.defineProperty(target, property.name, {
        configurable: false,
        enumerable: true,
        get: property.getter,
        set: property.setter
    });
}
exports.Property$generateStaticProperty = Property$generateStaticProperty;
function Property$generatePrototypeProperty(property, target) {
    Object.defineProperty(target, property.name, {
        configurable: false,
        enumerable: true,
        get: property.getter,
        set: property.setter
    });
}
exports.Property$generatePrototypeProperty = Property$generatePrototypeProperty;
function Property$generateOwnProperty(property, obj) {
    Object.defineProperty(obj, property.name, {
        configurable: false,
        enumerable: true,
        get: property.getter,
        set: property.setter
    });
}
exports.Property$generateOwnProperty = Property$generateOwnProperty;
function Property$pendingInit(obj, prop, value) {
    if (value === void 0) { value = null; }
    var pendingInit;
    if (Object.prototype.hasOwnProperty.call(obj, "__pendingInit__")) {
        pendingInit = obj.__pendingInit__;
    }
    else {
        Object.defineProperty(obj, "__pendingInit__", { enumerable: false, value: (pendingInit = {}), writable: true });
    }
    if (arguments.length > 2) {
        if (value === false) {
            delete pendingInit[prop.name];
        }
        else {
            pendingInit[prop.name] = value;
        }
    }
    else {
        var currentValue = obj.__fields__[prop.name];
        return currentValue === undefined || pendingInit[prop.name] === true;
    }
}
exports.Property$pendingInit = Property$pendingInit;
function Property$subArrayEvents(obj, property, array) {
    array.changed.subscribe(function (args) {
        Property$pendingInit(obj, property, false);
        // Don't raise a no-op list change event
        if (!args.changes.length)
            return;
        // NOTE: oldValue is not currently implemented for lists
        var eventArgs = { entity: obj, property: property, newValue: array };
        // Assign additional collection change event arguments to the property change event
        var additionalArgs = __assign({ changes: args.changes, collectionChanged: true }, args.additionalArgs);
        property.containingType.model.listChanged.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
        property.changed.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
        obj.changed.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
    });
}
function Property$getInitialValue(property) {
    // Constant
    if (property.isConstant)
        return typeof property.constant === "function" ? (property.constant = property.constant()) : property.constant;
    var val = property.defaultValue;
    if (Array.isArray(val)) {
        val = observable_array_1.ObservableArray.ensureObservable(val);
        // Override the default toString on arrays so that we get a comma-delimited list
        // TODO: Implement toString on observable list?
        // val.toString = Property$_arrayToString.bind(val);
    }
    return val;
}
function Property$init(property, obj, val) {
    Property$pendingInit(obj, property, false);
    Object.defineProperty(obj.__fields__, property.name, { value: val, writable: true });
    if (Array.isArray(val)) {
        Property$subArrayEvents(obj, property, observable_array_1.ObservableArray.ensureObservable(val));
    }
    // TODO: Implement observable?
    obj.changed.publish(obj, { entity: obj, property: property, newValue: val });
}
exports.Property$init = Property$init;
function Property$ensureInited(property, obj) {
    // Determine if the property has been initialized with a value and initialize the property if necessary
    if (!obj.__fields__.hasOwnProperty(property.name)) {
        Property$pendingInit(obj, property, true);
        // Do not initialize calculated properties. Calculated properties should be initialized using a property get rule.
        if (!property.isCalculated) {
            var setPendingInit = !property.isConstant;
            Property$init(property, obj, Property$getInitialValue(property));
            if (property.initializer) {
                obj.update(property.name, property.initializer.call(obj));
                setPendingInit = false;
            }
            // Mark the property as pending initialization if the property value may need to
            // be established by a default calculation rule, or some other external logic.
            // This is not relevant if it is a constant or its value is established via an initilizer.
            if (setPendingInit)
                Property$pendingInit(obj, property, true);
        }
    }
}
function Property$getter(property, obj) {
    // Ensure that the property has an initial (possibly default) value
    Property$ensureInited(property, obj);
    // Raise access events
    property.accessed.publish(obj, { entity: obj, property: property, value: obj.__fields__[property.name] });
    obj.accessed.publish(obj, { entity: obj, property: property });
    // Return the property value
    return obj.__fields__[property.name];
}
function Property$setter(property, obj, val, additionalArgs) {
    if (additionalArgs === void 0) { additionalArgs = null; }
    // Ensure that the property has an initial (possibly default) value
    Property$ensureInited(property, obj);
    var old = obj.__fields__[property.name];
    if (Property$shouldSetValue(property, obj, old, val)) {
        Property$setValue(property, obj, old, val, additionalArgs);
    }
    else {
        // Set pendingInit to false here, since the setter is not called since the value is not changing
        Property$pendingInit(obj, property, false);
    }
}
exports.Property$setter = Property$setter;
function Property$shouldSetValue(property, obj, old, val) {
    if (!property.canSetValue(obj, val)) {
        throw new Error("Cannot set " + property.name + "=" + (val === undefined ? "<undefined>" : val) + " for instance " + obj.meta.type.fullName + "|" + obj.meta.id + ": a value of type " + (type_1.isEntityType(property.propertyType) ? property.propertyType.meta.fullName : helpers_1.parseFunctionName(property.propertyType)) + " was expected.");
    }
    for (var _i = 0, _a = property.rules; _i < _a.length; _i++) {
        var rule = _a[_i];
        if (rule instanceof allowed_values_rule_1.AllowedValuesRule && rule.preventInvalidValues && !rule.values(obj).includes(val) && val !== null && val !== undefined) {
            throw new Error("Cannot set " + property.name + ", \"" + val + "\" is not an allowed value.");
        }
    }
    // Update lists as batch remove/add operations
    if (property.isConstant) {
        throw new Error("Constant properties cannot be modified.");
    }
    else {
        // compare values so that this check is accurate for primitives
        var oldValue = (old === undefined || old === null) ? old : old.valueOf();
        var newValue = (val === undefined || val === null) ? val : val.valueOf();
        // Do nothing if the new value is the same as the old value. Account for NaN numbers, which are
        // not equivalent (even to themselves). Although isNaN returns true for non-Number values, we won't
        // get this far for Number properties unless the value is actually of type Number (a number or NaN).
        return (oldValue !== newValue && !(property.propertyType === Number && isNaN(oldValue) && isNaN(newValue)));
    }
}
function Property$setValue(property, obj, currentValue, newValue, additionalArgs) {
    if (additionalArgs === void 0) { additionalArgs = null; }
    // Update lists as batch remove/add operations
    if (property.isList) {
        var currentArray = currentValue;
        currentArray.batchUpdate(function (array) {
            observable_array_1.updateArray(array, newValue);
        }, additionalArgs);
        // Set pendingInit to false here, since an array change event will not be raised if there are no changes
        // (ex: array was previously an empty array and newValue is also an empty array).
        Property$pendingInit(obj, property, false);
    }
    else {
        var oldValue = currentValue;
        // Set or create the backing field value
        if (Object.prototype.hasOwnProperty.call(obj.__fields__, property.name)) {
            obj.__fields__[property.name] = newValue;
        }
        else {
            Object.defineProperty(obj.__fields__, property.name, { value: newValue, writable: true });
        }
        if (property.isIdentifier && newValue && newValue !== obj.meta.id) {
            // If the identifier property is set or changed, then change the object's id and re-pool with the new id
            obj.meta.type.changeObjectId(obj.meta.id, newValue);
        }
        Property$pendingInit(obj, property, false);
        // Do not raise change if the property has not been initialized.
        if (oldValue !== undefined) {
            var eventArgs = { entity: obj, property: property, newValue: newValue, oldValue: oldValue };
            property.containingType.model.afterPropertySet.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
            property.changed.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
            obj.changed.publish(obj, helpers_1.merge(eventArgs, additionalArgs));
        }
    }
}
function Property$makeGetter(property, getter) {
    return function (additionalArgs) {
        if (additionalArgs === void 0) { additionalArgs = null; }
        // ensure the property is initialized
        return getter(property, this, additionalArgs);
    };
}
function Property$makeSetter(prop, setter, skipTypeCheck) {
    // TODO: Is setter "__notifies" needed?
    // setter.__notifies = true;
    if (skipTypeCheck === void 0) { skipTypeCheck = false; }
    return function (val, additionalArgs) {
        if (additionalArgs === void 0) { additionalArgs = null; }
        setter(prop, this, val, additionalArgs, skipTypeCheck);
    };
}
